<template lang="pug">
.search-filters-group
  .search-filters-group__title(
    @click.stop.prevent="active = !active",
    @keyup.enter.stop.prevent="active = !active",
    :class="{ active }",
    role="button",
    tabindex="0"
  ) {{ group.name }}
  TransitionExpand
    .search-filters-group__options(v-if="active", key="filterGroup")
      .search-filters-group__options-inner
        slot
</template>

<script>
import TransitionExpand from "../../transitions/Expand.vue";
export default {
  name: "BlueFilterGroup",
  components: { TransitionExpand },
  props: ["group", "initiallyExpanded"],
  data() {
    return {
      active: this.initiallyExpanded,
    };
  },
  created() {
    const recurse = (filters) => {
      let hasSelections = false;
      filters.forEach((filter) => {
        if (filter.selected) {
          hasSelections = true;
        }
        else if (filter.filters && filter.filters.length) {
          if (recurse(filter.filters)) hasSelections = true;
        }
      });
      return hasSelections;
    };
    if (recurse(this.group.filters)) this.active = true;
  },
};
</script>


<style lang="scss" scoped>
.search-filters-group {
  display: flex;
  flex-direction: column;
  &:first-child {
    .search-filters-group__title {
      border-top: 1px solid var(--border-color);
    }
  }
  &:last-of-type {
    padding-bottom: 0.5rem;
    margin-bottom: 1.25rem;
  }

  &__title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0 1rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.3;
    cursor: pointer;
    border-bottom: 1px solid var(--border-color);
    color: var(--accordion-title-color);
    transition: var(--accordion-title-transition);
    &::before,
    &::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.625rem;
      height: 0.125rem;
      background-color: currentColor;
    }
    &::after {
      transition: transform 0.2s ease;
      transform: rotate(90deg);
    }
    &:hover {
      color: $blue;
    }
    &.active {
      &::after {
        transform: rotate(0deg);
      }
    }
    &.active,
    &:hover {
      color: var(--accordion-title-active-color);
    }
  }

  &__options {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--border-color);
  }

  &__options-inner {
    display: flex;
    flex-direction: column;
    padding: 0.875rem 0 0.875rem 0.875rem;
  }
}
</style>